module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Copyright.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "x1cip",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_vm._v("Copyright Information")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("True Tales of Ghostly Encounters")]), _vm._v(" © 2006 by Llewellyn Publications.  ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any matter whatsoever, including Internet usage, without written permission from Llewellyn Publications, except in the form of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("As the purchaser of this e-book, you are granted the non-exclusive, non-transferable right to access and read the text of this ebook on screen. The text may not be otherwise reproduced, transmitted, downloaded, or recorded on any other storage device in any form or by any means. ")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Any unauthorized usage of the text without express written permission of the publisher is a violation of the author’s copyright and is illegal and punishable by law.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("First e-book edition © 2011")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("E-book ISBN: 9780738730677")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Previously titled "), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("My Proof of Survival: Personal Accounts of Contact with the Hereafter")]), _vm._v(" 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Book design and project management by Joanna Willis")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Book layout and editing by Andrew Honigman")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Cover art © PhotoDisc")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Cover design by Kevin R. Brown")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn Publications does not participate in, endorse, or have any authority or responsibility concerning private business arrangements between our authors and the public.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Any Internet references contained in this work are current at publication time, but the publisher cannot guarantee that a specific reference will continue or be maintained. Please refer to the publisher’s website for links to current author websites.")]), _vm._v(" "), _c('p', {
    staticClass: "cip3-spab-cntr"
  }, [_vm._v("Llewellyn Publications ")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("2143 Wooddale Drive")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("Woodbury, MN 55125")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("www.llewellyn.com")]), _vm._v(" "), _c('p', {
    staticClass: "cip3-spab-cntr"
  }, [_vm._v("Manufactured in the United States of America")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273528bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0